import { useMemo } from "react";

import { PieChart } from "lucide-react";

import { DonutChart } from "./Charts";
import { donutFaixas } from "../../lib/faixa";
import { Card, CardTitle, Skeleton, EstadoVazio } from "../ui/primitives";

/** Card "Distribuição por faixa" reutilizável em qualquer escopo (escola,
 * região, rede): recebe só a contagem bruta de faixas e cuida do donut,
 * do estado de carregamento e do vazio. */
export function FaixaDonutCard({ faixas, loading = false, altura = 190 }) {
  const donut = useMemo(() => donutFaixas(faixas), [faixas]);
  return (
    <Card>
      <CardTitle>Distribuição por faixa</CardTitle>
      {loading ? (
        <Skeleton className="h-[190px] w-full" />
      ) : donut.length ? (
        <DonutChart data={donut} height={altura} />
      ) : (
        <EstadoVazio
          icon={<PieChart size={20} />}
          titulo="Sem dados de faixa"
          hint="Nenhum aluno com nota registrada no período."
          altura={altura}
        />
      )}
    </Card>
  );
}
